import { HttpHeaders } from '../queryClient/getMutationFn';

const WARNING_MARKER = '(warning)' as const;

type WarningMessage<T extends string> = `${typeof WARNING_MARKER}${T}`;

export const warningMessage = <T extends string>(
  message: T
): WarningMessage<T> => `${WARNING_MARKER}${message}`;

export const isWarningMessage = <T extends string = string>(
  message: any
): message is WarningMessage<T> =>
  typeof message === 'string' && message.startsWith(WARNING_MARKER);

export const parseWarningMessage = <T extends string>(
  message: T
): T extends WarningMessage<infer ParsedMessage> ? ParsedMessage : undefined =>
  (isWarningMessage(message)
    ? message.substring(WARNING_MARKER.length)
    : undefined) as any;

export const confirmationHeaders = (confirm?: boolean): HttpHeaders => {
  if (!confirm) {
    return {};
  }

  return {
    'Confirm-Warnings': true,
  };
};
